<table mat-table [dataSource]="dataSource" class="mat-elevation-z8" multiTemplateDataRows>

    <ng-container matColumnDef="payPS">
        <th mat-header-cell *matHeaderCellDef class="text-center font10"
            matTooltip="{{engLang ? 'Primary (1) or secondary (2) payment': 'Pago primario (1) ó secundario (2)'}}"
            matTooltipPosition="above">PS</th>
        <td mat-cell *matCellDef="let pay" class="text-center font10">
            {{pay.payPS}} </td>
    </ng-container>

    <ng-container matColumnDef="payedDt">
        <th mat-header-cell *matHeaderCellDef class="text-center font10">{{engLang ? 'Date': 'Fecha'}}</th>
        <td mat-cell *matCellDef="let pay" class="text-center font10">
            {{pay.payedDt}} </td>
    </ng-container>

    <ng-container matColumnDef="payMode">
        <th mat-header-cell *matHeaderCellDef class="font10">{{engLang ? 'Mode': 'Modo'}}</th>
        <td mat-cell *matCellDef="let pay" class="font10">
            {{pay.payMode}} </td>
    </ng-container>

    <ng-container matColumnDef="payCkNo">
        <th mat-header-cell *matHeaderCellDef class="font10">Ck&nbsp;No</th>
        <td mat-cell *matCellDef="let pay" class="font10">
            {{pay.payCkNo}} </td>
    </ng-container>

    <ng-container matColumnDef="payApCode">
        <th mat-header-cell *matHeaderCellDef class="font10"
            matTooltip="{{engLang ? 'Plan Internal Control No': 'Número de Control Interno del Plan'}}"
            matTooltipPosition="above">ICN</th>
        <td mat-cell *matCellDef="let pay" class="font10">
            {{pay.payApCode}} </td>
    </ng-container>

    <ng-container matColumnDef="payAmnt">
        <th mat-header-cell *matHeaderCellDef class="rtalign font10">{{engLang ? 'Payed': 'Pagado'}}</th>
        <td mat-cell *matCellDef="let pay" class="rtalign font10">
            {{pay.payAmnt}} </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true" class="pay-header-row"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="pay-row">
    </tr>

</table>